module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_01.afc693d3.jpg";